import Api from './Api';
class AnotacaoApi extends Api {
    async salvarAnotacao(idSessao, numeroProcesso, anotacao) {
        await this.fetch(
            this.configuracao.urlSessoes + idSessao + '/processos/' + numeroProcesso + '/anotacao',
            'POST',
            anotacao,
            [{ parametro: 'Content-type', valor: 'text/plain' }]
        );
    }

    async excluirAnotacao(idSessao, numeroProcesso) {
        await this.fetch(
            this.configuracao.urlSessoes + idSessao + '/processos/' + numeroProcesso + '/anotacao',
            'DELETE'
        );
    }

    async salvarComplementoAnotacao(idSessao, numeroProcesso, complementoAnotacao) {
        await this.fetch(
            this.configuracao.urlSessoes +
                idSessao +
                '/processos/' +
                numeroProcesso +
                '/complemento-anotacao',
            'POST',
            complementoAnotacao,
            [{ parametro: 'Content-type', valor: 'text/plain' }]
        );
    }

    async excluirComplementoAnotacao(idSessao, numeroProcesso) {
        await this.fetch(
            this.configuracao.urlSessoes + idSessao + '/processos/' + numeroProcesso + '/complemento-anotacao',
            'DELETE'
        );
    }
}

export default AnotacaoApi;
